import { useState } from 'react';
import { toast } from 'sonner';
import { Clapperboard, Plus } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { ShotFields, emptyShot } from './ShotFields';
import { addScene, errMsg } from '../../lib/aiStudioApi';

/** Manual "Director's Chair": the user designs every shot, camera and lens by hand. */
export function ShotForm({ project, catalog, voices, onAdded }) {
  const [shot, setShot] = useState(emptyShot());
  const [saving, setSaving] = useState(false);

  async function submit() {
    if (!shot.description.trim()) { toast.error('Describe what happens in this shot'); return; }
    setSaving(true);
    try {
      await addScene(project.id, { ...shot, description: shot.description.trim(), camera: shot.cinematography.camera_movement || '' });
      setShot({ ...emptyShot(shot.episode), cinematography: shot.cinematography });
      toast.success('Shot added — camera setup carried over for continuity');
      onAdded();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  }

  return (
    <Card className="border-neutral-800 bg-neutral-900/40 text-neutral-100" data-testid="manual-shot-form">
      <CardContent className="space-y-4 p-5">
        <div>
          <div className="flex items-center gap-2 text-base font-semibold"><Clapperboard size={16} className="text-amber-300" /> Director's Chair</div>
          <p className="text-xs text-neutral-500">Full manual control — pick camera direction, body, sensor, lens, film stock and light for every shot.</p>
        </div>
        <ShotFields project={project} catalog={catalog} voices={voices} value={shot} onChange={setShot} testPrefix="manual-shot" />
        <div className="flex justify-end">
          <Button onClick={submit} disabled={saving} className="bg-amber-500 text-neutral-900 hover:bg-amber-400" data-testid="manual-shot-add-btn">
            <Plus size={14} className="mr-1" /> {saving ? 'Adding…' : 'Add shot to timeline'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
